var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarExpand(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 11.75H27C27.6904 11.75 28.25 12.3096 28.25 13V27C28.25 27.6904 27.6904 28.25 27 28.25H13C12.3096 28.25 11.75 27.6904 11.75 27V13C11.75 12.3096 12.3096 11.75 13 11.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.7275V27.273",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3537 19.604L23.9652 20.0003L24.3537 20.3966C24.5683 20.1777 24.5683 19.8229 24.3537 19.604ZM23.1882 20.0003L20.6464 22.5931C20.4318 22.8119 20.4318 23.1668 20.6464 23.3857C20.861 23.6045 21.2089 23.6045 21.4234 23.3857L24.3537 20.3966L23.9652 20.0003L24.3537 19.604L21.4234 16.6149C21.2089 16.3961 20.861 16.3961 20.6464 16.6149C20.4318 16.8338 20.4318 17.1887 20.6464 17.4075L23.1882 20.0003Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarExpand);
export default __webpack_public_path__ + "static/media/sidebar-expand.32f69ce7.svg";
export { ForwardRef as ReactComponent };